
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/addPreset/addPage/pagePreview/multiplePresetIndication.scss.css.virtualfile';
        module.exports = {"multiplePresetIndication":"_multiplePresetIndication_7a2b9_7"};